/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ParentOrganizationSettingsDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const organizationParentGetOrganizationSettings = (
    organizationId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ParentOrganizationSettingsDTO>(
      {url: `/api/organizations/${organizationId}/parent/OrganizationParent`, method: 'GET', signal
    },
      );
    }
  

export const getOrganizationParentGetOrganizationSettingsQueryKey = (organizationId: number,) => {
    return [`/api/organizations/${organizationId}/parent/OrganizationParent`] as const;
    }

    
export const getOrganizationParentGetOrganizationSettingsQueryOptions = <TData = Awaited<ReturnType<typeof organizationParentGetOrganizationSettings>>, TError = ErrorType<unknown>>(organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationParentGetOrganizationSettings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationParentGetOrganizationSettingsQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationParentGetOrganizationSettings>>> = ({ signal }) => organizationParentGetOrganizationSettings(organizationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationParentGetOrganizationSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationParentGetOrganizationSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof organizationParentGetOrganizationSettings>>>
export type OrganizationParentGetOrganizationSettingsQueryError = ErrorType<unknown>


export function useOrganizationParentGetOrganizationSettings<TData = Awaited<ReturnType<typeof organizationParentGetOrganizationSettings>>, TError = ErrorType<unknown>>(
 organizationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationParentGetOrganizationSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationParentGetOrganizationSettings>>,
          TError,
          Awaited<ReturnType<typeof organizationParentGetOrganizationSettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationParentGetOrganizationSettings<TData = Awaited<ReturnType<typeof organizationParentGetOrganizationSettings>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationParentGetOrganizationSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationParentGetOrganizationSettings>>,
          TError,
          Awaited<ReturnType<typeof organizationParentGetOrganizationSettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationParentGetOrganizationSettings<TData = Awaited<ReturnType<typeof organizationParentGetOrganizationSettings>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationParentGetOrganizationSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOrganizationParentGetOrganizationSettings<TData = Awaited<ReturnType<typeof organizationParentGetOrganizationSettings>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationParentGetOrganizationSettings>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationParentGetOrganizationSettingsQueryOptions(organizationId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



